var exports = {
  "nP": "flexContainer-Q290Y",
  "C5": "linkBox-Q290Y",
  "Mf": "tab-Q290Y",
  "Pf": "label-Q290Y",
};

module.exports = exports;
